import { Button } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import stateContext from "../../Context/StateContext";
import plateSizeOptions from "../../utils/plateSizeOptions";
import goldPrizeCalculator from "../../utils/goldPlateUtils";

export default function FontSize() {
  const globalState = useContext(stateContext);

  const [activeSizes, setActiveSizes] = useState([]);
  const [sortedData, setSortedData] = useState([]);

  const isArabic = globalState.selectedFontLanguage === "Arabic";

  const allSizes = [
    {
      value: "small",
      label: isArabic ? "صغير" : "Small",
      icon: "size-icon.svg",
    },
    {
      value: "medium",
      label: isArabic ? "وسط" : "Medium",
      icon: "size-icon2.svg",
    },
    {
      value: "large",
      label: isArabic ? "كبير" : "Large",
      icon: "size-icon3.svg",
    },
  ];

  // Use selectedFontData as the single source of truth
  useEffect(() => {
    const sfd = globalState.selectedFontData;
    if (!sfd || !sfd.fontSizes) {
      setActiveSizes([]);
      setSortedData([]);
      return;
    }

    const sizesFromSelected = Array.isArray(sfd.fontSizes.sizes)
      ? sfd.fontSizes.sizes.map((s) => String(s).toLowerCase())
      : [];
    setActiveSizes(sizesFromSelected);

    // Build sortedData (UI objects) from allSizes filtered by sizesFromSelected
    const newSorted = allSizes.filter((a) =>
      sizesFromSelected.includes(a.value.toLowerCase())
    );
    setSortedData(newSorted);

    // pick default (prefer medium if available)
    const defaultSize = sizesFromSelected.includes("medium")
      ? "medium"
      : sizesFromSelected[0];
    const attachMentSize = globalState.selectedFontData.attachmentSize.sizes;
    if (defaultSize && attachMentSize) {
      // Find matching key ignoring case
      const matchedKey = Object.keys(attachMentSize).find(
        (k) => k.toLowerCase() === defaultSize.toLowerCase()
      );

      if (matchedKey) {
        const numericValue = Number(
          attachMentSize[matchedKey].replace(/mm/i, "").trim()
        );
        if (!isNaN(numericValue)) {
          globalState.setActiveDiamondSize(numericValue);
        }
      }
    }
    if (defaultSize && globalState.currentRawPlateSize !== defaultSize) {
      const newPlateSize = plateSizeOptions.getPlate(defaultSize);
      goldPrizeCalculator.updateData({
        pWidth: newPlateSize.width,
        pHeight: newPlateSize.height,
      });
      globalState.setCurrentRawPlateSize(defaultSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState.selectedFontData, globalState.selectedFontLanguage]);

  const handleSizeChange = (size) => {
    const newPlateSize = plateSizeOptions.getPlate(size);
    goldPrizeCalculator.updateData({
      pWidth: newPlateSize.width,
      pHeight: newPlateSize.height,
    });
    globalState.setCurrentRawPlateSize(size);

    const attachmentSizes = globalState.selectedFontData?.attachmentSize?.sizes;

    if (attachmentSizes) {
      const matchedKey = Object.keys(attachmentSizes).find(
        (k) => k.toLowerCase() === size.toLowerCase()
      );

      if (matchedKey) {
        const numericValue = Number(
          attachmentSizes[matchedKey].replace(/mm/i, "").trim()
        );
        if (!isNaN(numericValue)) {
          globalState.setActiveDiamondSize(numericValue);
        }
      }
    }
  };

  return (
    <div className="size-buttons">
      {sortedData.map((size) => (
        <Button
          key={size.value}
          variant="contained"
          onClick={() => handleSizeChange(size.value)}
          className={
            globalState.currentRawPlateSize === size.value ? "active" : ""
          }
        >
          <div
            className="font-svg"
            style={{
              maskImage: `url('${process.env.PUBLIC_URL}/assets/images/${size.icon}')`,
              WebkitMaskImage: `url('${process.env.PUBLIC_URL}/assets/images/${size.icon}')`,
              mask: `url('${process.env.PUBLIC_URL}/assets/images/${size.icon}')`,
            }}
          />
          <span style={{ fontWeight: isArabic ? 600 : "normal" }}>
            {size.label}
          </span>
        </Button>
      ))}
    </div>
  );
}
